module.exports = __webpack_public_path__ + "img/VIRTUAL_ACCOUNT_BANK_BRI.5b34096f.png";